export enum ERROR_CODES {
  USER_NOT_FOUND = "USER_NOT_FOUND",
  ADMIN_ALREADY_EXISTS = "ADMIN_ALREADY_EXISTS",
}
